import {actions} from '../slice';
import {createAction} from '@reduxjs/toolkit';

export default createAction(actions.addPayment.type);
